import * as React from 'react'
import { Sparkle } from '@phosphor-icons/react'
import { trackEvent } from 'app/packs/src/services/event-tracker'
import { EVENT_KEY_NAME } from 'components/get-started-modal/shared'

const HREF = '/framework-builder'

export const GenerateWithAi = () => (
  <a
    href={HREF}
    onClick={() => {
      trackEvent(EVENT_KEY_NAME, {
        title: 'Generate Framework with AI',
        href: HREF,
      })
    }}
    className="flex-1 flex flex-row gap-x-4 items-center text-left border-px border-solid border-gray-100 hover:border-gray-200 rounded-lg p-4 transition-colors"
  >
    <div className="rounded bg-green-light text-progression-green p-7 flex items-center justify-center">
      <Sparkle aria-hidden weight="bold" size="24" />
    </div>
    <div className="flex flex-col gap-y-1">
      <h3 className="font-bold text-gray-900 text-sm">
        Generate Framework with AI
      </h3>
      <p className="text-gray-600 text-xs mb-0">
        Answer a few questions about your team and we&apos;ll draft a first
        framework for you to edit.
      </p>
    </div>
  </a>
)
